import { lazy } from "react";
import MapIcon from "@mui/icons-material/Map";
import ModeOfTravelIcon from "@mui/icons-material/ModeOfTravel";
// import ForkRightIcon from "@mui/icons-material/ForkRight";

const TripView = lazy(() => import("../components/tripView"));
const ManualEdit = lazy(() => import("../../manual-edit"));
const SpocTripView = lazy(() => import("../components/spocTripView"));
const RouteMapComparisonPage = lazy(() => import("../../route-map"));

const LogsRoute = {
    //   icon: MapIcon,
    //   name: "Routing",
    //   link: "/routing",
    //   path: "routing",
    //   index: 60,
    //   element: "",
    //   superAdminView: false,
    //   children : [
    icon: MapIcon,
    name: "Trip Management",
    link: "/trip-management",
    path: "trip-management",
    index: 8,
    element: "",
    superAdminView: false,
    children: [
        {
            path: "trip",
            element: <TripView />,
            permission: "Trip-Read",
            name: "Trips",
            index: 6,
            link: "trip-management/trip",
            icon: ModeOfTravelIcon,
        },
        {
            path: "manual-edit/:selectedDate/:selectedShiftTime/:passedShiftType/:isAutoRoute/:requestType",
            element: <ManualEdit />,
            permission: "Trip Requests-Read",
            // name: "Manual Edit",
            // index: 4,
            // link: "trip-management/manual-edit",
            // icon: ForkRightIcon,
        },

        {
            path:"route-map/:date/:shiftTime/:type/:requestType",
            element:<RouteMapComparisonPage />, 
            permission:"Trip Requests-Read",
            },

        {
            path: "spoc-trip",
            element: <SpocTripView />,
            permission: "Trip Spoc-Read",
            name: "Trips",
            index: 6,
            link: "trip-management/spoc-trip",
            icon: ModeOfTravelIcon,
        },

        // ${selectedDate}/${selectedShift?.time}/${passedShiftType

        // {
        //   path: "transport-team/view/:id",
        //   element: <TransporterView />,
        // },
    ],
};
export default LogsRoute;
